export const FIELDS_TO_CHECK = [
  "company_name",
  "person_first_name",
  "person_last_name",
];

export const FIELDS_TO_PREFILL = [
  "person_first_name",
  "full_name",
  "person_full_name",
  "company_name"
];

const MULTI_CASE_ACCESS_FIELDS = [
  "assigned_in_some_cases",
  "assigned_in_all_cases",
  "has_access",
]

const CASE_ACCESS_FIELDS = [
  "has_access",
]

export const CASE_ACCESS_FIELDS_MAP = {
  MULTI: MULTI_CASE_ACCESS_FIELDS,
  SINGLE: CASE_ACCESS_FIELDS,
}
